import TreeContainer from "../../../components/tree/TreeContainer";
import React from "react";

export default function AlberoStrutturaMacrocategorieView({
                                                              treeData,
                                                              macrocategoriaSel,
                                                              vociClickDestro
                                                          }) {

    return (
        <div className={'ns-overflow-auto ns-overflow-tree'}>
            <TreeContainer
                data={treeData}
                idSelected={macrocategoriaSel && macrocategoriaSel.id}
                onClickItem={(item) => {
                }}
                getLabel={(elemento) => elemento.codice + ' - ' + elemento.label}
                getFigli={(elemento) => elemento.nodes}
                initEsploso={true}
                icona={(el) => <i className={el.icona_classe}/>}
                vociClickDestro={vociClickDestro}
            >
            </TreeContainer>
        </div>
    );
}